import { AxiosInstance, AxiosRequestConfig, AxiosPromise } from 'axios';
import { CPAPResponse, ItemResponse, t_cpap_instructions } from '../types';

class ItemsService {
  private readonly axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  updateItem(data: t_cpap_instructions, related_ds_items?: any): AxiosPromise<ItemResponse> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/${data.d_id}/items/edit/${data.i_id}`,
      data: {
        item: data,
        use_display_id: true,
        is_force_update: true,
        return_item_result: true,
        related_ds_items: related_ds_items,
      },
    };
    return this.axios(request);
  }

  getDetailCPAP(param: string): AxiosPromise<CPAPResponse> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_cpap_instructions/items/search`,
      data: {
        per_page: 1,
        page: 1,
        use_display_id: true,
        conditions: [
          {
            search_value: [param],
            data_type: 'text',
            id: 'i_id',
            exact_match: true,
          },
        ],
        include_links: true,
        include_lookups: true,
      },
    };
    return this.axios(request);
  }
  filterCPAP(params: {
    conditions: any;
    per_page?: number;
    page?: number;
    disable_include_links?: boolean;
    disable_include_lookups?: boolean;
    disable_sort_num?: boolean;
    format?: boolean;
    sort_fields?: Array<{
      id: string;
      order: 'asc' | 'desc';
    }>;
  }): AxiosPromise<CPAPResponse> {
    const data: any = {
      per_page: params.per_page ?? 0,
      page: params.page ?? 1,
      use_display_id: true,
      conditions: params.conditions,
      include_links: params.disable_include_links ? undefined : true,
      include_lookups: params.disable_include_lookups ? undefined : true,
      format: params.format ? 'csv' : undefined,
    };
    if (params.disable_sort_num) {
      data.sort_field_id = 'created_at';
      data.sort_order = 'desc';
    } else {
      if (params.sort_fields && params.sort_fields.length > 0) {
        data.sort_fields = params.sort_fields;
      } else {
        data.sort_fields = [
          { id: 'sort_num', order: 'asc' },
          { id: 'created_at', order: 'asc' },
        ];
      }
    }
    const request: AxiosRequestConfig = {
      url: `applications/CPAP/datastores/t_cpap_instructions/items/search`,
      method: 'POST',
      data,
    };
    return this.axios(request);
  }
  getItemDetail(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/${param.d_id}/items/details/${param.i_id}?format=map`,
    };
    return this.axios(request);
  }
}

export default ItemsService;
